import { OutlinedInput, InputLabel } from '@material-ui/core';

import {
  withStyles,
  makeStyles
} from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  oneTimePaymentContainer: {
    display: 'flex',
    alignItems: 'inherit',
    justifyContent: 'space-between',
  },
  bodySmallFont: {
    color: 'rgba(0,0,0,0.87)',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    letterSpacing: '0.25px',
    lineHeight: '16px',
  },
  radioBtnLabel: {
    color: '#0F355C',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 'bold',
    letterSpacing: '0.53px',
    lineHeight: '19px',
  },

  swtichBack: {
    color: '#535D6D;',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    letterSpacing: '0.36px',
    lineHeight: '19px',
    textAlign: 'right',
    cursor: 'pointer',
    backgroundColor: 'none',
    textDecoration: 'underline',
    border: 'none',
    '&:hover': {
      border: 'none',
      textDecoration: 'underline',
      backgroundColor: 'none',
    }
  },

  radioBtn: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottom: '1px solid #d9d9d9',
    padding: '0px 15px 10px 0px',
    color: '#7B8390',
    '&:last-child': {
      borderBottom: 'none',
    },
    '& .MuiTypography-root.MuiFormControlLabel-label': {
      color: 'rgba(0,0,0,0.87)',
      fontWeight: '600',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      letterSpacing: '0.53px',
      lineHeight: '19px',
    },
    '& .Mui-checked + .MuiTypography-root.MuiFormControlLabel-label': {
      color: 'rgba(0,0,0,0.87)',
      fontWeight: '600',
    },
    '& .MuiRadio-root.Mui-checked': {
      color: '#535D6D'
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: '18px 0px'
    },
    '& .MuiFormControlLabel-root': {
      [theme.breakpoints.down('md')]: {
        width: '90%',
      },
    },
    '& .MuiBox-root': {
      [theme.breakpoints.down('sm')]: {
        width: '100% !important',
      },
    },
  },
  radioInfo: {
    color: '#535D6D'
  },

  paymentRadioInfo: {
    color: '#535D6D',
    fontSize: '20px'
  },

  addPayRadioInfo: {
    color: '#235A86',
    fontSize: 24, marginRight: '6px'
  },

  radioDes: {
    paddingLeft: '32px !important',
  },

  alignSelftEnd: {
    marginTop: '10px !important',
    [theme.breakpoints.down('sm')]: {
      alignSelf: 'flex-end',
    },
  },

  alignTextBox: {
    marginTop: 10
  },

  paymentDetailsBox: {
    background: '#eaeced',
    width: '100%',
    borderLeft: '1px solid #c6c6c6;',
    borderRadius: 8,
    [theme.breakpoints.up('md')]: {
      width: '50%',
      position: 'relative'
    },
    [theme.breakpoints.down('sm')]: {
      borderLeft: 'none',
    },
  },

  posRelative: {
    position: 'relative'
  },
  paymentTypeBox: {
    borderLeft: 'none'
  },
  paymentDetails: {
    padding: '10px 12px 52px 12px',
    [theme.breakpoints.down('sm')]: {
       padding: '0px 12px 20px 12px'
    },
  },
  paymentHeading: {
    color: 'rgba(0,0,0,0.87)',
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: '500',
    letterSpacing: '0.15px',
    lineHeight: '24px',
    paddingBottom: '9px !important',
    borderBottom: '1px solid #c6c6c6',
    paddingTop: '10px'
  },
  otpSubHeading: {
    color: 'rgba(0,0,0,0.87)',
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: '400',
    letterSpacing: '0.44px',
    lineHeight: '24px',
    paddingBottom: '9px !important',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  
  paymentType: {
    color: 'rgba(0,0,0,0.87)',
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: '400',
    letterSpacing: '0.44px',
    lineHeight: '24px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16
    },
  },
  paymentBreaks: {
    padding: '0px 30px 0px 30px',
    [theme.breakpoints.down('sm')]: {
      padding: '22px 0 13px 0',
    },
  },
  paymentBreakBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
    marginTop: 10
  },
  block: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  bodyFont: {
    color: 'rgba(0,0,0,0.74)',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: '500',
    letterSpacing: '0.5px',
    lineHeight: '20px',
  },
  bodyTitle: {
    color: 'rgba(0,0,0,0.87)',
    fontSize: '16px',
    fontWeight: '600',
    letterSpacing: '0.5px',
    lineHeight: '20px',
    fontFamily: 'Montserrat'
  },

  paymentDetailsFont: {
    color: '#515252',
    fontSize: '20px',
    fontWeight: 'bold',
    letterSpacing: '0.15px',
    lineHeight: '24px',
  },

  paymentDetailsTotal: {
    color: 'rgba(0,0,0,0.87)',
    fontSize: '20px',
    fontWeight: 'bold',
    letterSpacing: '0.15px',
    lineHeight: '24px',
  },

  paymentTotalBox: {
    borderTop: '2px solid #c6c6c6'
  },
  paymentTotal: {
    padding: "13px 30px 20px 30px",
    [theme.breakpoints.down('sm')]: {
      padding: "13px 0 20px 0",
    },
  },

  termNCon: {
    marginTop: 16,
    paddingBottom: 8,
    fontWeight: '500',
    borderBottom: '1px solid #c6c6c6',
    color: 'rgba(0,0,0,0.87)',
  },

  btns: {
    // display: 'flex',
    // justifyContent: 'space-between',
    paddingTop: 20,
    paddingBottom: 10,
    position: 'absolute',
    bottom: 0,
    width: '90%',
    // display: 'grid',
    justifyContent: 'end',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      position: 'relative',
      flexDirection: 'column',
      alignItems: 'center',
    },
    '& button': {
      // width: '230px',
      fontFamily: 'Montserrat',
      fontSize: '14px',
      fontWeight: '600',
      letterSpacing: '1.43px',
      lineHeight: '16px',
      marginTop: 26,
      float: 'right',
      [theme.breakpoints.down('sm')]: {
        marginBottom: 10
      },
    }
  },

  cancelBtn: {
    boxShadow: '0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)',
    '&:hover': {
      border: "2px solid",
      borderColor: theme.palette.primary.main,
    }
  },

  additionalDetails: {
    padding: '32px 0 10px 0'
  },
  addAccLink: {
    padding: '10px 0 0'
  },
  pt0: {
    paddingTop: 0,
  },
  ptPhone0: {
    [theme.breakpoints.down('xs')]: {
      paddingTop: 0,
    },
  },
  addRemovePay: {
    display: 'flex',
    alignItems: 'center',
    color: '#235A86;',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '0.36px',
    lineHeight: '19px',
    textDecoration: 'underline',
    cursor: 'pointer',
    width: 'fit-content',
  },

  inputStyle: {
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600"
  },
  inputContainer: {
    marginBottom: '25px',
    width: '70%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  termNConitionBox: {
    boxSizing: "border-box",
    height: "162px",
    border: "1px solid rgba(156,156,156,0.5)",
    backgroundColor: "#FFFFFF",
    marginTop: "1em",
    paddingLeft: "1.6em",
    paddingRight: ".8em",
    paddingTop: "1.3em",
    marginBottom: '14px',
  },

  tncTextContainer: {
    color: "#202020",
    fontFamily: "Montserrat",
    fontSize: "16px",
    letterSpacing: "0.36px",
    lineHeight: "19px",
    height: "115px",
    overflow: "auto",
    paddingRight: "0",
  },

  printButton: {
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      marginBottom: '8em'
    },

  },

  printBtnIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: "600",
    cursor: 'pointer',
    color: '#535D6D',
    textDecoration: 'underline',
  },

  alignCenter: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between'
    },
  },
  bankAccountError: {
    color: 'red',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontWeight: 600,
    letterSpacing: '0.36px',
    lineHeight: '19px',
    marginBottom: 6,
    marginTop: 20,
  },
  // successmsg popup
  successMsgBox: {
    textAlign: 'center',
  },
  popupHeading: {
    color: '#0F355C',
    fontFamily: 'Montserrat',
    fontSize: '24px',
    fontWeight: '500',
    letterSpacing: 0,
    lineHeight: '29px',
    textAlign: 'center',
  },

  popupSubHeading: {
    color: '#0C0B0B',
    fontFamily: 'Montserrat',
    fontSize: '12px',
    letterSpacing: '0.4px',
    lineHeight: '15px',
    textAlign: 'center',
  },
  amountDetailBox: {
    border: '1px solid #979797',
    opacity: '0.12',
    backgroundColor: '#25ABC7',
    padidng: 12,
  },
  popupCode: {
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: '0.53px',
    lineHeight: '19px',
    textAlign: 'center',
  },
  poupAmountDetails: {
    display: 'flex',

  },
  disabledBtn: {
    backgroundColor: '#94aecf !important'
  },
  // end
  apiErrorBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  apiError: {
    color: 'red',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: '0.53px',
    lineHeight: '19px',
    textAlign: 'center',
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100vh'
  },
  loader1: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '350vh'
  },
  addedAccount: {
    padding: '2px 10px 2px 10px',
    width: '70%',
    '& .MuiFormControl-root': {
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '32px 0 0 0',
    },
    '& .MuiFormLabel-root': {
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: 600,
      letterSpacing: '0.36px',
      lineHeight: '19px',
      backgroundColor: '#fff',
      paddingRight: 4,
    },
    '& .MuiOutlinedInput-input': {
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: 600,
      letterSpacing: '0.36px',
      lineHeight: '19px',
    },
  },

  errorMsg: {
    color: 'red',
    // textAlign: 'center',
    fontSize: 14,
    fontFamily: 'Montserrat',
    fontWeight: '600',
    lineHeight: '16px',
    letterSpacing: '0.36px',
    // position: 'absolute',
    marginBottom: '-22px',
    // bottom: '210px',
    right: 0,
    left: 0,
    margin: '0 auto',
    width: '90%',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      bottom: 0,
    },
  },

  errorMsg1: {
    color: 'black',
    // textAlign: 'center',
    fontSize: 12,
    fontFamily: 'Montserrat',
    fontWeight: '600',
    lineHeight: '16px',
    letterSpacing: '0.36px',
    // marginBottom: '-38px',
    // position: 'absolute',
    // bottom: '90px',
    right: 0,
    left: 0,
    // margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      bottom: 0,
    },
  },
  errorMsg2: {
    marginTop: 12,
    color: 'black',
    // textAlign: 'center',
    fontSize: 12,
    fontFamily: 'Montserrat',
    fontWeight: '600',
    lineHeight: '19px',
    letterSpacing: '0.36px',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      bottom: 0,
    },
  },

  payingMoreLink: {
    color: '#535D6D',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    letterSpacing: '0.36px',
    lineHeight: '19px',
    textAlign: 'right',
    display: 'flex',
    alignItems: 'center',

  },
  warning: {
    display: 'flex',
    fontSize: '16px',
    '&>div': {
      color: '#535D6D',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: '500',
      letterSpacing: '0.31px',
      lineHeight: '19px',
    },
    '& p': {
      color: 'red',
      margin: 0,
      fontSize: 14
    },
    '& h5': {
      fontWeight: '500',
    }
  },
  textField: {
    color: "#585757",
    fontFamily: "Montserrat",
    fontSize: " 16px",
    fontWeight: '600'
  },

  infoBox: {
    border: "solid 1px",
    borderColor: theme.palette.primary.main,
    borderRadius: 12,
    backgroundColor: "#fff9f3",
    padding: '12px 15px',
    margin: '25px 25px 37px 25px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('xs')]: {
      margin: '25px 25px 20px 25px',
    },
  },

  infoBoxText: {
    fontFamily: "Montserrat",
    fontSize: " 1.6em",
    color: 'rgba(0,0,0,0.74)',
    fontWeight: '400',
    margin: 0,
  },

  infoBoxBtn: {
    fontFamily: "Montserrat",
    fontSize: " 1.6em",
    color: '#25ABC7',
    fontWeight: 'bold',
    textAlign: 'right',
  },

  flexEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  customTextInput: {
    paddingLeft: 32,
    marginBottom: 12
  },

  imageContainer: {
    display: "flex"
  },
  infoIcon: {
    paddingRight: "10px",
    fontSize: '30px',
    color: "#007FFF"
  },
  paragraph: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: "500",
    paddingTop: 5
 },
 spinner: {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100vh',
  flexDirection: 'column'
},
processing: {
  color: "#121D22",
  fontFamily: "Montserrat",
  fontSize: 30,
  fontWeight: "600",
  paddingTop: 10,
  [theme.breakpoints.down('sm')]: {
    fontSize: 20
  },
},
refresh: {
  color: "#121D22",
  fontFamily: "Montserrat",
  fontSize: 22,
  fontWeight: "500",
  paddingTop: 10,
  [theme.breakpoints.down('sm')]: {
    fontSize: 14
  },
},
processingFeeInfo: {
  color: '#535D6D',
  fontSize: '20px',
  marginRight: 168
},

//Payment Options


banner: {
  width: '100%',
  padding: '6px 40px',
  backgroundColor: "#F9CB7F",
  boxShadow: "0 3px 7px 0 rgba(0,0,0,0.14)",
  display: 'flex',
  alignItems: 'center',
  marginBottom: 24,
  borderRadius: 9,
},

redBanner: {
  width: '100%',
  padding: '8px 40px',
  backgroundColor: "#B91717",
  boxShadow: "0 3px 7px 0 rgba(0,0,0,0.14)",
  display: 'flex',
  alignItems: 'center',
  marginBottom: 30,
  borderRadius: 9,
},

greenBanner: {
  display: 'none'
},

countBox: {
  border: "solid 2px #585757",
  borderRadius: 8,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: 15
},

countText: {
  color: "#0D0D0D",
  fontFamily: "Montserrat",
  fontSize: 16,
  fontWeight: "600",
  padding: 6,
},

bannerText: {
  color: "#000000",
  fontFamily: "Montserrat",
  fontSize: "1.6em",
  fontWeight: "500",
},

whiteColor: {
  color: '#fff'
},

whiteBorder: {
  border: "solid 2px #FFF",
},

// schedule payment box
schedulePaymentBox: {
  boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 14px 7px, rgba(0, 0, 0, 0.2) 0px 1px 3px 0px',
  width: '100%',
  padding: '3em 2.2em',
  borderRadius: '12px',
  margin: '37px 0',
  backgroundColor: '#fff',
},

headingText: {
  color: 'rgba(0,0,0,0.87)',
  fontFamily: 'Montserrat',
  fontSize: '20px',
  fontWeight: '400',
  letterSpacing: '0.63px',
  lineHeight: '29px',
  marginBottom: 40,
},

disabledLink: {
  color: '#4D4D4D',
  fontFamily: 'Montserrat',
  fontSize: '16px',
  fontWeight: '600',
  letterSpacing: '0.5px',
  lineHeight: 'normal',
  textDecoration: 'none !important',
  cursor: 'pointer',
  fontStyle: 'normal',
},

activeLink: {
  color: '#121D22',
  fontFamily: 'Montserrat',
  fontSize: '16px',
  fontWeight: '600',
  letterSpacing: '0.5px',
  lineHeight: 'normal',
  textDecoration: 'none !important'
},

errText: {
  color: "red",
  fontFamily: "Montserrat",
  fontSize: "16px",
  fontWeight: "600",
  textAlign: 'center',
  padding: '2em',
},

printIconText: {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  cursor: 'pointer',
},

printForm: {
  fontSize: '14px',
  color: '#535D6D',
  fontFamily: "Montserrat",
  fontWeight: '600',
  textDecoration: 'underline',
},

flexBox: {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 20,
  borderBottom: '1px solid #d9d9d9'
},

marginFix: {
  marginBottom: 0
},
achSuspension: {
  color: 'red',
  marginBottom: 20
},

transferBox: {
  width: '100%',
  alignItems: 'center',
  backgroundColor: '#FFF2E1',
  borderRadius: 4,
  padding: '1em',
  borderRadius: '8px',
  border: '2px solid #EDB342'
},

recurringDraft: {
  width: '100%',
  alignItems: 'center',
  backgroundColor: '#1A4664',
  borderRadius: 4,
  padding: '1em',
  marginBottom: '2em',
},

warningIcon: {
  color: "#F7B15C",
  width: 25,
  height: 25,
  marginRight: 10
},

transferInfoIcon: {
  color: "rgba(0,0,0,0.87)",
  width: 25,
  height: 25,
  marginRight: 10,
  cursor: "pointer"
},

informationText: {
  color: "#235A86",
  fontFamily: "Montserrat",
  fontSize: 20,
  fontWeight: "600",
  [theme.breakpoints.down('sm')]: {
    fontSize: 16
  }
},

recurringDraftText: {
  color: "#FFFFFF",
  fontFamily: "Montserrat",
  fontSize: 16,
  fontWeight: 400,
  [theme.breakpoints.down('sm')]: {
    fontSize: 14
  }
},

enrollNow: {
  fontWeight: 700,
  textDecoration: 'underline',
  cursor: "pointer"
},

infoIcon: {
  color: "#007FFF",
  width: 25,
  height: 25,
  marginRight: 10
},

checkmarkIcon: {
  width: 25,
  height: 25,
  marginRight: 10
},

clickLink: {
  color: '#007FFF',
  fontFamily: 'Montserrat',
  fontSize: '16px',
  fontStyle: 'normal',
  cursor:'pointer',
  fontWeight: '700',
  lineHeight: '16px',
  textDecorationLine: 'underline'
},

confirmationStatusContainer: {
  border: '1px solid #235A86',
  backgroundColor: "#EFEFEF",
  borderRadius: 4,
  fontSize: 16,
  padding: "6px",
  color: '#121D22',
  fontWeight: "600",
  float: 'right',
  [theme.breakpoints.down('sm')]: {
    marginTop: 8
  },
},

paymentLine: {
  margin: '12px 0px 12px 0px',
  border: '1px solid #D9D9D9'
},

customPaymentText: {
  color: "#4D4D4D",
  fontFamily: "Montserrat",
  fontSize: 14,
  fontWeight: "500",
  paddingTop: 5
},

transactionHistory: {
  color: "#4D4D4D",
  fontFamily: "Montserrat",
  fontSize: 14,
  fontWeight: "500",
  paddingTop: 10
},

note: {
  color: "#000000",
  fontFamily: "Montserrat",
  fontSize: 14,
  fontWeight: "600",
  paddingTop: 5
},

bankAccount: {
  color: "#4D4D4D",
  fontFamily: "Montserrat",
  fontSize: 14,
  fontWeight: "600",
  padding: '5px 0px'
},

removeBank: {
  display: 'flex',
  alignItems: 'center',
  color: '#235A86;',
  fontFamily: 'Montserrat',
  fontSize: '14px',
  fontWeight: '600',
  letterSpacing: '0.36px',
  lineHeight: '19px',
  textDecoration: 'underline',
  cursor: 'pointer',
  width: 'fit-content',
  marginTop: 6
},

radioLabelDisable: {
  '& .MuiTypography-root.MuiFormControlLabel-label': {
    color: 'rgba(0,0,0,0.35) !important',
    fontWeight: '600',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    letterSpacing: '0.53px',
    lineHeight: '19px',
  },
},

radioLabelEnable: {
  '& .MuiTypography-root.MuiFormControlLabel-label': {
    color: 'rgba(0,0,0,0.87)',
    fontWeight: '600',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    letterSpacing: '0.53px',
    lineHeight: '19px',
  },
},

checkmark: {
  width: '24px',
  height: '24px'
},

zeroOutstanding: {
  width: '100%',
  padding: '8px 40px',
  backgroundColor: "#bee7c7",
  display: 'flex',
  alignItems: 'center',
  marginBottom: 30,
  border: '1px solid #D9D9D9',
  [theme.breakpoints.down('xs')]: {
    padding: '8px'
  },
},

clearOutstanding: {
  color: "#000000",
  fontFamily: "Montserrat",
  fontSize: 16,
  fontWeight: "600",
  marginLeft: 16,
  [theme.breakpoints.down('xs')]: {
    fontSize: 14
  },
},

autoPay: {
  width: '100%',
  padding: '10px 16px',
  backgroundColor: "#F4F4F4",
  alignItems: 'center',
  border: '1px solid #B4B4B4'
},

manageAutoPay: {
  color: '#1A4664',
  textDecoration: 'underline',
  fontFamily: "Montserrat",
  fontSize: 16,
  fontWeight: "600",
  cursor: 'pointer'
},

autoPayDate: {
  color: "#000000",
  fontFamily: "Montserrat",
  fontSize: 16,
  fontWeight: "400",
  marginLeft: 16
},

paymentNote: {
  padding: '10px 52px',
  alignItems: 'center',
  marginBottom: 20,
  border: '1px solid #B4B4B4',
  color: "#4D4D4D",
  fontFamily: "Montserrat",
  fontSize: 16,
  fontWeight: "400",
  [theme.breakpoints.down('xs')]: {
    padding: '10px',
  },
},

historyLink: {
  color: '#007FFF',
  textDecoration: 'underline',
  cursor: 'pointer'
},

pastDueDays: {
  width: '100%',
  padding: '10px 16px',
  backgroundColor: "#F4F4F4",
  alignItems: 'center',
  border: '1px solid #D9D9D9',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: 16,
  borderRadius: '4px 4px 0px 0px'
},

title: {
  color: "#000000",
  fontFamily: "Montserrat",
  fontSize: 18,
  fontWeight: '400'
},

paddingFix: {
  paddingTop: 16,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  
},

alertTitle: {
  color: "#B00020",
  fontFamily: "Montserrat",
  fontSize: '1.6em',
  fontWeight: "500",
  margin: 0,
  marginLeft: 5
},

contactUs: {
  color: "#B91717",
  fontWeight: 600
},

alertBtn: {
  width: 223,
  display: 'block',
  textTransform: "inherit",
  backgroundColor: "#F1CACA",
  color: "#B00020",
  fontFamily: "Montserrat",
  fontSize: '1.4em',
  fontWeight: "600",
  '&:hover': {
    backgroundColor: "#F1CACA",
  }
},

footerItem: {
  display: 'flex'
},

financialText: {
  fontFamily: 'Montserrat',
  fontSize: '14px',
  color: '#000000',
  fontWeight: '500',
  paddingLeft: 30
},

financialLink: {
  fontFamily: 'Montserrat',
  fontSize: '14px',
  color: '#000000',
  fontWeight: '600'
},

hardship: {
  width: '100%',
  padding: '10px 16px',
  backgroundColor: "#ffffff",
  alignItems: 'center',
  border: '1px solid #D9D9D9',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: 12,
  borderRadius: '0px 0px 4px 4px',
  marginBottom: 28
},

btn: {
  fontFamily: "Montserrat",
  fontSize: 16,
  fontWeight: "600",
  width: '236px'
},

regularPaymentDescEnable: {
  color: 'rgba(0,0,0,0.87)',
  fontFamily: 'Montserrat',
  fontSize: '14px',
  letterSpacing: '0.25px',
  lineHeight: '16px',
  paddingLeft: '32px !important'
},

regularPaymentDescDisable: {
  color: 'rgba(0,0,0,0.35)',
  fontFamily: 'Montserrat',
  fontSize: '14px',
  letterSpacing: '0.25px',
  lineHeight: '16px',
  paddingLeft: '32px !important'
},

disableBodyTitle: {
  color: 'rgba(0,0,0,0.35)',
  fontSize: '16px',
  fontWeight: '600',
  letterSpacing: '0.5px',
  lineHeight: '20px',
  fontFamily: 'Montserrat',
},

additionalPayment: {
  color: 'rgba(0,0,0,0.87)',
  fontFamily: 'Montserrat',
  fontSize: 20,
  fontWeight: '400',
  letterSpacing: '0.44px',
  lineHeight: '24px',
  paddingBottom: '9px !important'
},

liquidationText: {
  color: "#121D22",
  fontFamily: "Montserrat",
  fontSize: 16,
  fontWeight: "500",
  marginBottom: 8,
  paddingTop: 8,
  lineHeight: '24px'
},

tick: {
  width: '16px', 
  height: '16px',
  marginRight: 10,
  marginTop: 10
},

link: {
  color: '#007FFF',
  textDecoration: 'underline',
  cursor: 'pointer'
},

liquidationBox: {
  width: '100%',
  alignItems: 'center',
  backgroundColor: '#F4F4F4',
  borderRadius: 4,
  padding: '1em',
  borderRadius: '8px',
  border: '2px solid #D9D9D9',
  marginBottom: 18
},

paymentAckFooterSection: {
  paddingTop: 30,
  display: 'flex',
  justifyContent: 'center'
},

homePageBtn: {
  width: '200px',
  fontFamily: "Montserrat",
  fontSize: '1.6em',
  marginLeft: 20,
  fontWeight: "600",
  letterSpacing: "0.53px",
  lineHeight: "19px",
  textAlign: "center",
  height: '40px',
  [theme.breakpoints.down('xs')]: {
    width: 'auto',
  },
},

disabledAdditionalPrincipal: {
  fontFamily: "Montserrat",
  fontSize: 16,
  fontWeight: "600",
  background: '#e5e3e3'
},

fieldDisable: {
  color: "#235A86",
  fontFamily: "Montserrat",
  fontSize: 10,
  fontWeight: "700",
  marginBottom: 22,
  textDecoration: 'underline'
},

flexBoxAdditionalPayment: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '& .MuiTypography-body1': {
    paddingBottom: '0 !important',
    borderBottom: 'None',
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  [theme.breakpoints.down('xs')]: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
},

additionalPrincipal: {
  color: "#4D4D4D",
  fontFamily: "Montserrat",
  fontSize: 14,
  fontWeight: "500",
  padding: "0px 12px"
},

servicerText: {
  color: "#121D22",
  fontFamily: "Montserrat",
  fontSize: 15,
  fontWeight: "700",
  textTransform: 'uppercase'
},

contactTime: {
  color: '#121D22',
  fontWeight: '700',
  fontSize: 16
},

noUnderLine: {
  textDecoration: 'none'
},

iconStyle: {
  height: 14,
  width: 16, 
  color: '#121D22', 
  marginLeft: '6px'
},

informationTexts: {
  color: "#121D2",
  fontFamily: "Montserrat",
  fontSize: 15,
  fontWeight: "400"
},

spocInfo: {
  color: "#121D2",
  fontFamily: "Montserrat",
  fontSize: 15,
  fontWeight: "600",
  padding: '10px 0px'
},

callUs: {
  color: "#121D2",
  fontFamily: "Montserrat",
  fontSize: 15,
  fontWeight: "400"
},

spocContainer: {
  alignItems: 'center',
  backgroundColor: '#FFF2E1',
  borderRadius: 4,
  padding: '10px 18px',
  margin: "1em 0em",
  borderRadius: '8px',
  border: '2px solid #EDB342'
},

information: {
  color: "#000000",
  fontFamily: "Montserrat",
  fontSize: '1.6em',
  fontWeight: "400"
},

contact: {
  color: '#007FFF',
  cursor: "pointer",
  textDecoration: 'underline',
  fontFamily: "Montserrat"
},

oneTimePaymentBkContainer: {
  display: 'flex',
  alignItems: 'inherit',
  justifyContent: 'space-between',
  height: '620px',
  [theme.breakpoints.down('sm')]: {
    height: '100%'
  },
},

  paymentOptionsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '15px'
    },
  },

}));


export const CutomOutlinedInput = withStyles({
  root: {
    "&$focused $notchedOutline": {
      border: `2px solid #25abc7`
    }
  },
  focused: {},
  notchedOutline: {}
})(OutlinedInput);

export const CustomInputLabel = withStyles({
  root: {
    "&$focused": {
      color: "#25abc7",
    }
  },
  focused: {},
})(InputLabel);

export const useStylesBootstrap = makeStyles((theme) => ({
  arrow: {
    color: '#25ABC7',
    fontSize: '40px'
  },
  tooltip: {
    color: "#fff",
    backgroundColor: '#25ABC7',
    padding: '20px 15px',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    letterSpacing: '0.55px',
    lineHeight: '21px',
    width: '500px',
    maxWidth: '500px',
    borderRadius: '10px'
  },
}));